{
  "name": "semantria-dashboard",
  "version": "2.42.3-rc03081",
  "scripts": {
    "ng": "ng",
    "serve": "ng serve --host 0.0.0.0",
    "start": "ng serve --host 0.0.0.0",
    "start:dev": "ng serve --host 0.0.0.0 --configuration=dev",
    "start:preprod": "ng serve --host 0.0.0.0 --configuration=preprod",
    "build": "node --max-old-space-size=8000 ./node_modules/@angular/cli/bin/ng.js build",
    "build:prod": "node --max-old-space-size=8000 ./node_modules/@angular/cli/bin/ng.js build --configuration production",
    "test": "node --max-old-space-size=8000 ./node_modules/@angular/cli/bin/ng.js test --karma-config karma.conf.js --browsers=Chrome",
    "test:headless": "node --max-old-space-size=8000 ./node_modules/@angular/cli/bin/ng.js test --karma-config karma.conf.js --no-watch --no-progress --browsers=ChromeHeadless",
    "test:ci": "./test-runner.sh",
    "format:fix": "pretty-quick --staged",
    "format:check": "prettier --config ./.prettierrc --list-different \"src/**/*{.ts,.js,.json,.css,.scss,.html}\"",
    "format:all": "prettier --config ./.prettierrc --write \"src/**/*{.ts,.js,.json,.css,.scss,.html}\"",
    "lint": "ng lint",
    "lint:fix": "ng lint --fix",
    "e2e": "ng e2e",
    "postinstall": "patch-package",
    "prepare": "husky install",
    "postbuild:prod": "node ./post-build-prod.js"
  },
  "private": true,
  "dependencies": {
    "@acrodata/code-editor": "^0.5.1",
    "@angular-slider/ngx-slider": "^19.0.0",
    "@angular/animations": "^19.2.14",
    "@angular/cdk": "^19.2.19",
    "@angular/common": "^19.2.14",
    "@angular/compiler": "^19.2.14",
    "@angular/core": "^19.2.14",
    "@angular/forms": "^19.2.14",
    "@angular/localize": "^19.2.14",
    "@angular/material": "^19.2.19",
    "@angular/platform-browser": "^19.2.14",
    "@angular/platform-browser-dynamic": "^19.2.14",
    "@angular/platform-server": "^19.2.14",
    "@angular/router": "^19.2.14",
    "@fullstory/browser": "^1.6.2",
    "@inmoment/stonly": "^0.0.2",
    "@inmoment/the-kitchen": "^21.5.1",
    "@inmoment/the-kitchen-angular": "^21.5.1",
    "@jsverse/transloco": "^7.6.1",
    "@jsverse/transloco-messageformat": "^7.0.1",
    "@jufab/opentelemetry-angular-interceptor": "^1.4.1-5",
    "@ngrx/signals": "^19.2.1",
    "@ng-bootstrap/ng-bootstrap": "^18.0.0",
    "@opentelemetry/instrumentation-user-interaction": "^0.39.0",
    "@popperjs/core": "^2.11.6",
    "@types/file-saver-es": "2.0.1",
    "@types/humanize-plus": "^1.8.0",
    "@types/moment-timezone": "^0.5.13",
    "@types/socket.io-client": "^1.4.32",
    "@types/stacktrace-js": "0.0.32",
    "@types/uuid": "^3.4.4",
    "angular-froala-wysiwyg": "^4.2.1",
    "angular-gridster2": "^19.0.0",
    "angular-split": "^17.2.0",
    "bootstrap": "^5.3.8",
    "eslint-config-prettier": "^8.5.0",
    "eslint-plugin-prettier": "^5.0.0",
    "file-saver-es": "^2.0.0",
    "highcharts": "^12.1.2",
    "html-to-image": "^1.11.11",
    "humanize-plus": "^1.8.2",
    "karma-cli": "^1.0.1",
    "lru-cache": "^8.0.4",
    "marked": "^15.0.12",
    "moment": "^2.23.0",
    "moment-timezone": "^0.5.34",
    "ng-animate": "^2.0.1",
    "ng-table-virtual-scroll": "^1.6.0",
    "ng2-file-upload": "^8.0.0",
    "ngx-logger": "^5.0.11",
    "ngx-markdown": "^19.1.1",
    "object-hash": "^3.0.0",
    "pptxgenjs": "^4.0.1",
    "rxjs": "^7.8.0",
    "select2": "^4.1.0-rc.0",
    "socket.io-client": "^2.2.0",
    "stacktrace-js": "^2.0.0",
    "stringz": "^2.1.0",
    "tslib": "^2.0.0",
    "url-search-params-polyfill": "^8.1.0",
    "uuid": "^11.0.0",
    "webpack": "^5.76.3",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-builders/custom-webpack": "^19.0.1",
    "@angular-devkit/build-angular": "^19.2.15",
    "@angular-devkit/core": "^19.2.15",
    "@angular-eslint/builder": "18.4.3",
    "@angular-eslint/eslint-plugin": "18.4.3",
    "@angular-eslint/eslint-plugin-template": "18.4.3",
    "@angular-eslint/schematics": "18.4.3",
    "@angular-eslint/template-parser": "18.4.3",
    "@angular/cli": "^19.2.15",
    "@angular/compiler-cli": "^19.2.14",
    "@angular/language-service": "^19.2.14",
    "@jsverse/transloco-validator": "^7.0.1",
    "@opentelemetry/api": "^1.4.1",
    "@opentelemetry/context-zone-peer-dep": "^1.15.2",
    "@opentelemetry/core": "^1.15.2",
    "@opentelemetry/exporter-trace-otlp-http": "^0.53.0",
    "@opentelemetry/exporter-zipkin": "^1.15.2",
    "@opentelemetry/instrumentation": "^0.53.0",
    "@opentelemetry/instrumentation-document-load": "^0.33.1",
    "@opentelemetry/instrumentation-fetch": "^0.53.0",
    "@opentelemetry/instrumentation-xml-http-request": "^0.53.0",
    "@opentelemetry/propagator-aws-xray": "^1.3.1",
    "@opentelemetry/propagator-b3": "^1.15.2",
    "@opentelemetry/propagator-jaeger": "^1.15.2",
    "@opentelemetry/resources": "^1.15.2",
    "@opentelemetry/sdk-trace-base": "^1.15.2",
    "@opentelemetry/sdk-trace-web": "^1.15.2",
    "@opentelemetry/semantic-conventions": "^1.15.2",
    "@types/humanize-plus": "^1.8.0",
    "@types/jasmine": "~4.6.0",
    "@types/jasminewd2": "~2.0.3",
    "@types/marked": "^5.0.2",
    "@types/moment": "^2.13.0",
    "@types/moment-timezone": "^0.5.13",
    "@types/node": "^16.18.21",
    "@types/promise.allsettled": "^1.0.3",
    "@types/react": "^18.3.1",
    "@types/react-dom": "^18.3.1",
    "@types/socket.io-client": "^1.4.32",
    "@types/stacktrace-js": "0.0.32",
    "@types/uuid": "^10.0.0",
    "@typescript-eslint/eslint-plugin": "latest",
    "@typescript-eslint/parser": "latest",
    "@typescript-eslint/utils": "latest",
    "eslint": "^8.57.1",
    "eslint-plugin-import": "latest",
    "eslint-plugin-jsdoc": "^51.2.3",
    "eslint-plugin-prefer-arrow": "latest",
    "husky": "^8.0.0",
    "jasmine-core": "~4.6.0",
    "jasmine-spec-reporter": "~5.0.0",
    "karma": "^6.3.17",
    "karma-chrome-launcher": "~3.1.0",
    "karma-coverage": "~2.0.3",
    "karma-coverage-istanbul-reporter": "~3.0.2",
    "karma-jasmine": "~4.0.0",
    "karma-jasmine-html-reporter": "^1.5.0",
    "karma-junit-reporter": "^1.2.0",
    "karma-spec-reporter": "0.0.32",
    "lint-staged": "^15.2.0",
    "merge-config": "^2.0.0",
    "ngx-spec": "^2.1.6",
    "npm-run-all": "^4.1.5",
    "patch-package": "^6.5.0",
    "prettier": "^3.6.2",
    "pretty-quick": "^4.2.2",
    "react": "^18.3.1",
    "react-dom": "^18.3.1",
    "ts-node": "~7.0.0",
    "typescript": "^5.8.3"
  },
  "overrides": {
    "@opentelemetry/context-zone-peer-dep": {
      "zone.js": "~0.15.0"
    },
    "@opentelemetry/instrumentation-user-interaction": {
      "zone.js": "~0.15.0"
    },
    "merge-config": {
      "js-yaml": "~3.13.1"
    }
  }
}
